/**
 * Downloads a file by fetching it as a blob and triggering a download with the specified filename.
 * This ensures the filename is controlled client-side, regardless of server-side Content-Disposition headers.
 *
 * @param url - The URL of the file to download
 * @param filename - The desired filename for the downloaded file
 */
export const downloadFile = async (
  url: string,
  filename: string,
): Promise<void> => {
  try {
    const response = await fetch(url);

    if (!response.ok) {
      console.warn('Failed to download file', response.status);

      return;
    }

    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);

    const anchor = document.createElement('a');

    anchor.href = objectUrl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(objectUrl);
  } catch (error) {
    console.warn('Failed to download file', error);
  }
};
